import React, { Fragment, useState } from 'react';
import {
  Card, Button, UncontrolledDropdown, Modal, ModalHeader, ModalFooter, ModalBody,
  DropdownMenu, DropdownItem, DropdownToggle, Row, Input

} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import {
  putAPI_Update_Promo_Codes, dAPI_Vouchers_By_Id,
} from '../../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import moment from 'moment';
import PromoCodeForm from './PromoCodeForm';
import Validation from '../../../../../../../components/Validation';
const PromoListItem = ({ item, LoadPromoCodes, currency, vouchers }) => {
  const [id, setId] = useState(item.id);
  const [isUpdating, setIsUpdating] = useState(false);
  ;

  const [deleteVisible, setDeleteVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);

  const handleVoucherDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Vouchers_By_Id}/${id}`,
    }).then((res) => {
      setDeleteVisible(false);
      LoadPromoCodes();
    });
  }
  const toggle = () => {
    setDeleteVisible(false);
  }


  const handlePromoCode = (data) => {
    AxiosAPI({
      url: `${putAPI_Update_Promo_Codes}/${id}`,
      method: 'put',
      data: data
    }).then((res) => { if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
      && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
    }
    else { 
      setIsUpdating(!isUpdating);
      LoadPromoCodes()}})
      .catch((err) => null);
  };

  const handleUpdate = (id) => {    
    setId(id);
    setIsUpdating(true);
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This item will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleVoucherDelete(item.id)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>

      <Fragment>

        <Colxx xxs="12">
          <Card className="d-flex flex-row mb-3">

            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <p className="mb-1 text-center text-muted text-small w-25 w-sm-100">
                  <b>{item.promoCode}</b>
                </p>
                {item.promoType === 'Amount' ?
                  <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                    {currency} {item.promoCodeValue}
                  </p> :
                  <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                    {item.promoCodeValue}%
                  </p>}

                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {moment(item.startDate).format('YYYY-MM-DD')}
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {moment(item.endDate).format('YYYY-MM-DD')}
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">

                  {item.promoStatus === 'Active' ? <span style={{ color: 'green' }}>{item.promoStatus} </span> :
                    <span style={{ color: 'red' }}>{item.promoStatus}</span>}
                </p>

                < UncontrolledDropdown className="w-15 text-center w-sm-100">
                  <DropdownToggle caret color="outline-dark" size="xs">
                    more
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      key='Accept'
                      onClick={() => handleUpdate(item.id)}
                    >Edit
                    </DropdownItem>
                    {/* <DropdownItem
                      key='Accept'
                    //onClick={() => setDeleteVisible(true)}
                    >Delete
                    </DropdownItem> */}

                  </DropdownMenu>

                </UncontrolledDropdown>
              </div>
            </div>
          </Card >
        </Colxx >
        <div>
          {isUpdating && (
            <PromoCodeForm
              formLabel="Update the E-GIft Card"
              isVisible={isUpdating}
              vouchers={vouchers}
              toggle={() => {
                setIsUpdating(!isUpdating);
              }}
              id={id}
              handleSubmit={handlePromoCode}
            />
          )}
        </div>
      </Fragment>
      {generateDeleteButton()}
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment >
  );
}

export default React.memo(PromoListItem);





